export function request(body) {
    return {
        type: 'GET_ALL_BANNERS_REQUEST',
        body
    };
}

export function error(errors) {
    return {
        type: 'GET_ALL_BANNERS_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'GET_ALL_BANNERS_FINISH',
        data
    };
}
